"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { _getGeoDataSource, _getGeoDataSourceIds } from "./queries";
const countGeoDataSource = (..._0) => __async(void 0, [..._0], function* (params = {}, callback = void 0) {
  const { filters = [], locale, isIndex = false, offset = 0, first = 50 } = params;
  const fields = [];
  const searchParams = new URLSearchParams({
    locale,
    offset,
    first
  });
  if (isIndex) {
    searchParams.append("is_index", "true");
  }
  filters.forEach((f) => {
    searchParams.append("filters[]", JSON.stringify(f));
  });
  fields.forEach((f) => searchParams.append("fields[]", f));
  let page;
  try {
    const response = yield fetch(
      "/api/decidim-geo/points/count?" + searchParams.toString()
    );
    if (response.ok) page = yield response.json();
    else throw new Error(yield response.text());
  } catch (error) {
    console.error(error);
    throw error;
  }
  if (!page) return;
  if (callback) callback(page.count);
  return page.count;
});
export default countGeoDataSource;
